import React, { Component, PropTypes } from 'react';
import debounce from 'lodash/debounce';

import { isValid } from '../validate';

import Label from '../label';

import css from './text.scss';

export default class InputText extends Component {
	static propTypes = {
		name: PropTypes.string.isRequired,
		type: PropTypes.string,
		btw: PropTypes.string.isRequired,
		// error: PropTypes.oneOf([
		// 	PropTypes.bool,
		// 	PropTypes.array,
		// 	PropTypes.null,
		// ]),
		value: PropTypes.oneOfType([
			PropTypes.string,
			PropTypes.number,
		]),
		error: PropTypes.bool,
		disabled: PropTypes.oneOf([1, 0, true, false]),
		validate: PropTypes.array,
		manualValidate: PropTypes.bool,
		hideLabel: PropTypes.bool,
		onChange: PropTypes.func,
		maxChars: PropTypes.number.isRequired,
	};

	static defaultProps = {
		type: 'text',
		error: undefined,
		value: '',
		btw: '',
		manualValidate: false,
		hideLabel: false,
		maxChars: 0,
		onChange: () => {},
	};

	constructor(props) {
		super();

		this.valid = (typeof props.error === 'undefined') ? true : !props.error;

		this.state = {
			value: '' + props.value,
			valid: this.valid,
		};
	}

	shouldComponentUpdate(nextProps, nextState) {
		return (
			this.props !== nextProps ||
			this.state.valid !== nextState.valid ||
			this.state.value !== nextState.value
		);
	}

	componentWillReceiveProps(nextProps) {
		const newState = { ...this.state };
		if (nextProps.error && nextProps.error !== this.props.error) {
			this.valid = !nextProps.error;
			newState.valid = this.valid;
		}

		if (nextProps.value !== this.props.value) {
			newState.value = '' + nextProps.value;
		}

		this.setState(newState);
	}

	render() {
		let className = 'custom-input__input';
		let hideLabel = this.props.hideLabel || this.props.type === 'hidden';
		let btw = this.props.btw;

		if (this.props.className) {
			className += ` ${this.props.className}`;
		}

		if (!this.state.valid || this.props.error) {
			className += ' invalid';
		}

		if (this.props.disabled) {
			className += ' disabled';
		}

		if (this.props.maxChars) {
			btw += ` (${this.charRemaining(this.state.value)} characters left)`;
		}

		return (
			<Label name={this.props.name} label={this.props.label} btw={btw} hideLabel={hideLabel} className='relative'>

				{/* output input type text with all the given props as attributes */}
				<input key='input' type={this.props.type} id={this.props.name} {...this.props} ref='input' disabled={false} value={this.state.value} onChange={(e) => this.onChange(e)} className={className} />

				{this.renderError(this.props.error)}

			</Label>
		);
	}

	renderError(errors) {
		if (typeof errors !== 'object') {
			return false;
		}

		return (
			<div className='custom-input__error'>
				{errors.map((error, i) => {
					return (
						<span key={i}>{error}</span>
					);
				})}
			</div>
		);
	}

	charRemaining(value) {
		if (!this.props.maxChars) {
			// when no max is set, always return 1
			return 1;
		}

		const remaining = this.props.maxChars - value.length;
		return remaining;
	}

	value(val) {
		if (!this) {
			return '';
		}

		if (val !== undefined) {
			return this.setState({
				...this.state,
				value: val,
			});
		}

		let newVal = this.state.value;
		if (this.refs.input && this.refs.input.value && (this.refs.input.value !== this.state.value)) {
			newVal.valid = this.refs.input.value;
		}

		this.state.value = newVal;

		return newVal;
	}

	onChange(e) {
		if (this.props.disabled) {
			return false;
		}
		const newState = {
			...this.state,
		};

		let newVal = this.state.value;
		if (e && e.target) {
			newState.value = e.target.value;
		}

		if (!this.props.manualValidate && this.props.validate) {
			this.valid = isValid(newState.value, this.props.validate, this.props.error);
			newState.valid = this.valid;
		}

		// console.log('setState: ', newState.value);

		this.setState(newState);

		this.props.onChange(newState.value);
	}

	testValidity() {
		this.valid = isValid(this.value(), this.props.validate, this.props.error);
		this.setState({ ...this.state, valid: this.valid });

		return this.valid;
	}
}



/** WEBPACK FOOTER **
 ** ./frontend/components/form/input/text.js
 **/